import axios from 'axios';

const createTicketOtrs = async (email: string, nom: string, prenom: string, compte: string) => {
    try {
        const response = await axios.post('/api/create-ticket', {
            mail: email,
            nom: nom,
            prenom: prenom,
            gestCompte: compte,
        });
        console.log('Données de réponse du serveur:', response.data);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la requête createTicketOtrs:', error);
        throw error;
    }
};

export {createTicketOtrs};
